export enum BackgroundFit {
  Cover = "cover",
  Contain = "contain",
}
